import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';

const PageBreadcrumbs = ({ crumbs }) => (
	<Breadcrumbs
		sx={{
			my: 2,
		}}
		data-testid='page-breadcrumbs'
	>
		{crumbs.map((c, i) =>
			i !== crumbs.length - 1 ? (
				<Typography
					key={c.link}
					variant='body1'
					color='text.secondary'
					component={RouterLink}
					style={{ textDecoration: 'none' }}
					to={c.link}
				>
					{c.text}
				</Typography>
			) : (
				<Typography key={c.link} variant='body1' color='text.primary'>
					{c.text}
				</Typography>
			)
		)}
	</Breadcrumbs>
);

PageBreadcrumbs.propTypes = {
	crumbs: PropTypes.arrayOf(
		PropTypes.shape({
			link: PropTypes.string.isRequired,
			text: PropTypes.string.isRequired,
		})
	).isRequired,
};

export default PageBreadcrumbs;
